/**
 * Pass-through props for PrimeReact's ToggleButton (the Yes/No answer-key toggles).
 *
 * PrimeReact 10 gives the toggle's checkbox `role="switch"` and also `aria-pressed`,
 * which a switch may not carry: axe reports it as `aria-allowed-attr`, critical, and a
 * screen reader may announce a toggle button instead of a switch. The checkbox's own
 * checked state already says on or off, so this drops `aria-pressed` (mergeProps lets
 * the pass-through override it). ADR 0113 §2.
 */
export const TOGGLE_PT = { input: { 'aria-pressed': undefined } };
